module.exports = __webpack_public_path__ + "static/media/RetailSale-Flyer.62dd40fc.pdf";